var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2544_46322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0228 4.11896V9.11896M20.0228 9.11896H15.0228M20.0228 9.11896L16.1561 5.48563C15.2605 4.58955 14.1525 3.93496 12.9354 3.58294C11.7184 3.23091 10.432 3.19292 9.19636 3.47251C7.96067 3.7521 6.81595 4.34015 5.86901 5.18181C4.92206 6.02346 4.20376 7.09128 3.78112 8.28563M1.68945 17.4523V12.4523M1.68945 12.4523H6.68945M1.68945 12.4523L5.55612 16.0856C6.45174 16.9817 7.55976 17.6363 8.77679 17.9883C9.99382 18.3403 11.2802 18.3783 12.5159 18.0987C13.7516 17.8192 14.8963 17.2311 15.8432 16.3894C16.7902 15.5478 17.5085 14.48 17.9311 13.2856",
    stroke: "#00535C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2544_46322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.856445 0.785645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.ef91e06fb7c8a360533b55b759d67dab.svg";
export { ForwardRef as ReactComponent };